// Meta Pixel event helpers — CONSENT-AWARE
// El snippet en /public/index.html inyecta el fbq stub pero NO ejecuta init ni PageView.
// Solo activamos el Pixel cuando el usuario ha dado consentimiento de marketing.

import { hasMarketingConsent } from "../hooks/useCookieConsent";

const PIXEL_ID = "1694254525189623";
let initialized = false;

function initIfAllowed() {
  if (initialized) return true;
  if (typeof window === "undefined" || typeof window.fbq !== "function") return false;
  if (!hasMarketingConsent()) return false;
  try {
    window.fbq("init", PIXEL_ID);
    window.fbq("track", "PageView");
    initialized = true;
    return true;
  } catch {
    return false;
  }
}

// Si el usuario otorga consentimiento más tarde, escuchamos el evento para arrancar el Pixel.
if (typeof window !== "undefined") {
  window.addEventListener("plazafy:consentChanged", () => {
    if (hasMarketingConsent() && !initialized) initIfAllowed();
  });
  // Intento inicial por si ya había consentimiento guardado al cargar la página.
  initIfAllowed();
}

const isAvailable = () =>
  typeof window !== "undefined" &&
  typeof window.fbq === "function" &&
  hasMarketingConsent();

export function trackEvent(eventName, params) {
  if (!isAvailable()) return;
  if (!initIfAllowed()) return;
  try {
    if (params) {
      window.fbq("track", eventName, params);
    } else {
      window.fbq("track", eventName);
    }
  } catch {
    // Silently ignore — tracking failures should never break the app
  }
}

export function trackPageView() {
  trackEvent("PageView");
}

export function trackRegistration(method) {
  trackEvent("CompleteRegistration", { content_name: method || "email" });
}

export function trackSearch(query) {
  trackEvent("Search", { search_string: query || "" });
}

export function trackViewContent(spotId, spotTitle, price) {
  trackEvent("ViewContent", {
    content_ids: [spotId],
    content_name: spotTitle,
    content_type: "parking_spot",
    value: price,
    currency: "EUR",
  });
}

export function trackAddToWishlist(spotId, spotTitle, price) {
  trackEvent("AddToWishlist", {
    content_ids: [spotId],
    content_name: spotTitle,
    content_type: "parking_spot",
    value: price,
    currency: "EUR",
  });
}

export function trackPurchase(value, spotId, spotTitle) {
  trackEvent("Purchase", {
    value: Number(value || 0),
    currency: "EUR",
    content_ids: spotId ? [spotId] : undefined,
    content_name: spotTitle,
    content_type: "parking_spot",
  });
}

export function trackInitiateCheckout(value, spotId, spotTitle) {
  trackEvent("InitiateCheckout", {
    value: Number(value || 0),
    currency: "EUR",
    content_ids: spotId ? [spotId] : undefined,
    content_name: spotTitle,
    content_type: "parking_spot",
  });
}

export function trackLead(contentName) {
  trackEvent("Lead", { content_name: contentName || "add_spot" });
}
